<script setup lang="ts">
import { computed } from 'vue'

import { PatientType } from '@/types'
import { ComboboxAutocomplete } from '@/ui'

import SearchResultPatient from './SearchResultPatient.vue'

const props = defineProps<{
  searchValue?: string
  options?: PatientType[]
  classNames?: string
  inputWrapperClassNames?: string
  inputClassNames?: string
  isFetching?: boolean
  disabled?: boolean
  resetSearchTermOnBlur?: boolean
}>()

const emits = defineEmits<{
  (event: 'select', value: string): void
  (event: 'update:searchValue', value: string): void
}>()

const search = computed({
  get: () => props.searchValue || '',
  set: (value: string) => {
    emits('update:searchValue', value)
  },
})
</script>

<template>
  <ComboboxAutocomplete
    v-model:search-term="search"
    :options="options || []"
    :class-names="classNames"
    :input-wrapper-class-names="inputWrapperClassNames"
    :input-class-names="inputClassNames"
    :is-loading="isFetching"
    :disabled="disabled"
    :reset-search-term-on-blur="resetSearchTermOnBlur"
    @update:model-value="emits('select', $event)"
  >
    <template #default="{ option }">
      <SearchResultPatient :patient="option as PatientType" />
    </template>
    <template #empty>
      <slot name="empty" :search="search" />
    </template>
  </ComboboxAutocomplete>
</template>
